import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../utils/api';
import { isNonProductionUrl } from 'src/utils/utils';

const ACKNOWLEDGE_RMD_DISCLAIMER = 'ACKNOWLEDGE_RMD_DISCLAIMER';
const RMD_INFORMATION = 'RMD_INFORMATION';
const RMD_INFORMATION_SUMMARY = 'RMD_INFORMATION_SUMMARY';
const EXISTING_RMD = 'EXISTING_RMD';
const DELETE_RMD = 'DELETE_RMD';

const DEFAULT_STATE = {
  disclaimerAccepted: false,
  isLoading: false,
  isLoaded: false,
  hasFailed: false,
  error: null,
  rmdLimitsData: {},
};

export default function RMDSetting(state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case ACKNOWLEDGE_RMD_DISCLAIMER: {
      const disclaimerAccepted = payload;
      return {
        ...state,
        disclaimerAccepted,
      };
    }
    case `${RMD_INFORMATION}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${RMD_INFORMATION}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        rmdLimitsData: payload.body,
        existingRMDData: payload.body.rmdSummary,
      };

    case `${RMD_INFORMATION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        rmdLimitsData: {},
        error: payload,
        existingRMDDate: {},
      };

    case `${RMD_INFORMATION_SUMMARY}_PENDING`:
      return {
        ...state,
        isSummaryLoaded: false,
        isSummaryLoading: true,
      };
    case `${RMD_INFORMATION_SUMMARY}_FULFILLED`:
      return {
        ...state,
        isSummaryLoaded: true,
        isSummaryLoading: false,
        rmdLimitsData: {
          ...payload.data,
        },
      };
    case `${RMD_INFORMATION_SUMMARY}_REJECTED`:
      return {
        ...state,
        isSummaryLoaded: true,
        isSummaryLoading: false,
        hasSummaryError: true,
        rmdLimitsData: {},
        summaryRrror: payload,
      };
    case `${EXISTING_RMD}_PENDING`:
      return {
        ...state,
        existingIsLoaded: false,
        existingIsLoading: true,
        deleteLoading: true,
      };
    case `${EXISTING_RMD}_FULFILLED`:
      return {
        ...state,
        existingIsLoaded: true,
        existingIsLoading: false,
        deleteLoading: false,
      };

    case `${EXISTING_RMD}_REJECTED`:
      return {
        ...state,
        existingIsLoaded: true,
        existingIsLoading: false,
        existingHasError: true,
        deleteLoading: false,
        error: payload,
      };
    case `${DELETE_RMD}_PENDING`:
      return {
        ...state,
        deleteLoaded: false,
        deleteLoading: true,
        deleteFailed: false,
      };
    case `${DELETE_RMD}_REJECTED`:
      return {
        ...state,
        deleteLoading: false,
        deleteFailed: true,
      };
    case `${DELETE_RMD}_FULFILLED`:
      return {
        ...state,
        deleteLoaded: true,
      };
    default:
      return state;
  }
}

export const updateDisclaimerRMD = (disclaimerAccepted) => {
  return createAction(ACKNOWLEDGE_RMD_DISCLAIMER)(disclaimerAccepted);
};

export const getRMDLimits = () => {
  let businessDate;
  if (isNonProductionUrl()) {
    businessDate = new URLSearchParams(window.location.search).get(
      'businessDate'
    );
  }
  const rmdSummaryEndpoint =
    getEndpoint('rmdInformation') +
    (businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : '');
  return () => {
    return createAction(RMD_INFORMATION)(callApi(rmdSummaryEndpoint));
  };
};

export const getRMDLimitsSummary = () => {
  return () => {
    return createAction(RMD_INFORMATION_SUMMARY)(
      callApi(getEndpoint('rmdEndpoint'))
    );
  };
};

export const getExistingRMD = () => {
  return (dispatch) => {
    const action = createAction(EXISTING_RMD)(
      callApi(getEndpoint('existingRMDEndpoint'))
    );
    return dispatch(action);
  };
};

export const deleteExistingRMD = (payload) => {
  return (dispatch) => {
    const action = createAction(DELETE_RMD)(
      callApi(
        getEndpoint('submitRMDapi'),
        {
          method: 'delete',
          requestBody: payload,
        },
        payload
      )
    );
    return dispatch(action);
  };
};
